import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

function Sidebar() {
    return (
        <div className="admin-sidebar">
            <div className="sidebar-header">
                <h2>Admin Panel</h2>
            </div>
            <nav className="sidebar-nav">
                {/* NavLink는 현재 활성화된 링크에 active 클래스를 자동으로 추가해줍니다. */}
                <NavLink to="/admin/users" className="sidebar-link">
                    사용자 관리
                </NavLink>
                <NavLink to="/admin/reports" className="sidebar-link">
                    신고 관리
                </NavLink>
                <NavLink to="/admin/notices" className="sidebar-link">
                    공지 관리
                </NavLink>
                {/* 나중에 추가될 다른 메뉴들... */}
            </nav>
        </div>
    );
}

export default Sidebar;